import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-address',
  templateUrl: './icon-address.component.html',
  styles: []
})
export class IconAddressComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
